import store from "@/store/index";
import { Route } from "vue-router";
export function AuthorizeModels(routerName?: string | null) {
  if (
    routerName !== "logout" &&
    routerName !== null &&
    routerName !== "sessionExpire" &&
    routerName !== "canNotAccessMerchant" &&
    routerName !== "statement" &&
    routerName !== "update"
  ) {
    if (routerName == "login") {
      store.dispatch("LogIn/DoGetRefreshTokenExpiration", { root: true });
    } else {
      store.dispatch("LogIn/AuthorizeModels", { root: true });
    }
  }
}

export function SetSessionEMIFromURL(emi: any) {
  let getSession: any = sessionStorage.getItem("userMerchant");
  getSession = JSON.parse(getSession);
  if (!getSession) {
    getSession = {
      eui: "",
      emi: emi,
    };
  } else {
    getSession.emi = emi ? emi : "";
  }
  sessionStorage.setItem("userMerchant", JSON.stringify(getSession));
}
export function SetLastUrl(to: Route) {
  if (
    to.name !== "sessionExpire" &&
    to.name !== "canNotAccessMerchant" &&
    to.name !== "logout" &&
    to.name !== "login" &&
    to.name !== "pageNotFound" &&
    to.name !== "update"
  ) {
    const query: any = Object.assign({}, to.query);

    let queryStr = "";
    for (const [key, value] of Object.entries(query)) {
      if (value) {
        queryStr += `${key}=${value}&`;
      }
    }

    localStorage.setItem("lastUrlPeakAsset", `${window.location.origin}${to.path}${queryStr ? "?" + queryStr : ""}`);
  }
}

export function ClearLastUrl() {
  localStorage.removeItem("lastUrlPeakAsset");
}
